import { QbBusiness as api } from '../../utils/business/qbbusiness'
import { push } from 'react-router-redux'
import appConst from '../../constant/appConst'

export const GET_STORY_REQUEST = 'GET_STORY_REQUEST'
export const GET_STORY_SUCCESS = 'GET_STORY_SUCCESS'
export const GET_STORY_ERROR = 'GET_STORY_ERROR'

const MANAGED_TYPES = ['story', 'focus', 'article']

// Affichage jusqu'au bloc de texte après un carrousel, une playlist ou un un album
export const getStory = (id, type) => dispatch => {
  if (!MANAGED_TYPES.includes(type)) {
    dispatch(push('/'))
  }
  dispatch({ type: GET_STORY_REQUEST })
  return api.getStory(id, type)
    .then(response => {
      // Renvoi sur la racine en cas de retour noContent
      if (response.status === 'error') {
        dispatch(push('/'))
        dispatch({ type: GET_STORY_ERROR, response })
      } else {
        const storyId = response._id
        const title = {
          title: response.headlines.basic,
          accroche: response.subheadlines.basic,
          author: response.credits.by[0].additional_properties.original.byline,
          date: response.display_date,
          type: response.taxonomy.sections[0].name
        }
        const image = {
          image: response.promo_items.basic.additional_properties.originalUrl,
          credits: response.promo_items.basic.caption
        }
        const carousel = {
          position: 2,
          type: appConst.story.layout.carousel,
          albums: {
            items: []
          }
        }
        const text = {
          position: 1,
          type: appConst.story.layout.text,
          descriptions: []
        }

        let isFirstAlbumContainer = true
        response.content_elements.forEach((element, i) => {
          if (element.type === 'custom_embed' && element.subtype === 'qobuz-albums') {
            if (isFirstAlbumContainer) {
              element.embed.config.objects.forEach((album) =>
                carousel.albums.items.push({
                  id: album.id,
                  title: album.title,
                  artist: album.artist ? {
                    id: album.artist.id,
                    name: album.artist.name
                  } : undefined,
                  track_count: album.tracks_count,
                  image: album.image ? album.image.small : undefined,
                  release_date_original: album.release_at,
                  sampleable: album.is_streamable,
                  hires: album.hires,
                  genre: album.genre ? album.genre.id : undefined,
                  award: album.awards && album.awards.length ? album.awards[0].name : undefined,
                  description: album.description ? album.description.content : undefined
                })
              )
              carousel.title = element.embed.config.title
              carousel.subtitle = element.embed.config.subtitle
              isFirstAlbumContainer = false
            }
          }
          if (element.type === 'text') {
            text.descriptions.push(element.content)
          }
        })
        dispatch({
          type: GET_STORY_SUCCESS,
          id: storyId,
          title,
          image,
          content: [text, carousel]
        })
      }
    })
    .catch(e => {
      push('/')
      dispatch({ type: GET_STORY_ERROR, e })
    })
}



// WEBPACK FOOTER //
// ./src/pages/story/storyActions.js